import { PayloadAction } from '@reduxjs/toolkit';

import { FuelCardsData, IState } from '../types/state';

const setFavoriteCatalogs = (
  state: IState,
  action: PayloadAction<FuelCardsData>,
) => {
  state.fuelCards.data = action.payload;
};

export default setFavoriteCatalogs;
